import React from 'react';
import {Link, withRouter} from 'react-router-dom';

import {Button} from 'reactstrap';

import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";

import HelpCenterIcon from '@material-ui/icons/ContactSupport';
import LogOutIcon from '@material-ui/icons/ExitToApp';
import PersonIcon from '@material-ui/icons/PersonOutline';
import HTTPSIcon from '@material-ui/icons/Https';

import API from "@beardeddevops/react.api";
import Lockable from "components/Lockable";
import Notification from './Notification';
import Types from "../../constants/Types";
import Framework from "@beardeddevops/react.framework";
import Access from "constants/Access";
import APPCONFIG from "constants/Config";
import ErrorBoundaryRoute from "../../containers/ErrorBoundaryRoute";

class NavRightList extends Lockable {

	constructor(props) {
		super(props);
		this.state.anchorEl = null;
		this.state.anchorE2 = null;
		this.model = new API.BuildClass(Types.Accounts._name, API.RequestType.READ);
	}

	handleRoute = (value) => () => {
		this.props.history.push(value);
		this.setState({
			anchorEl: null,
			anchorE2: null,
		});
	};

	handleAPIChange = (value) => () => {
		APPCONFIG.settings.apiURLOverride = value;
		localStorage.setItem('apiURLOverride', value);
		API.URL = APPCONFIG.settings.apiURL();
		this.handleClose();
	};

	handleOpen = (e) => {
		const el = e.currentTarget.name;

		this.setState({
			[el]: e.currentTarget,
		});
	};

	handleClose = () => {
		this.setState({
			anchorEl: null,
			anchorE2: null
		});
	};

	handleLogout = async (event) => {
		if (typeof event !== 'undefined') event.preventDefault();
		if (this.props.rootState.isAdmin) {
			let model = new API.BuildClass(Types.Admins_Locations._name, API.RequestType.READ);
			await model.submit(null, API.RequestType.DELETE);
			let OtherDomains = API.Domains.filter(domain => domain !== API.URL);
			for(let index in OtherDomains) {
				try {
					model.submit(null, API.RequestType.DELETE, false, false, false, OtherDomains[index]).then();
				} catch (e) { }
			}
			this.props.rootState.triggerAction('logout_admin');
		} else {
			await this.model.submit(null, API.RequestType.DELETE);
			let OtherDomains = API.Domains.filter(domain => domain !== API.URL);
			for(let index in OtherDomains) {
				try {
					this.model.submit(null, API.RequestType.DELETE, false, false, false, OtherDomains[index]).then();
				} catch (e) { }
			}
			this.props.rootState.triggerAction('logout');
		}
		return false;
	};

	// handleCloseSession = async (event) => {
	// 	if (typeof event !== 'undefined') event.preventDefault();
	// 	// noinspection JSIgnoredPromiseFromCall
	// 	await this.model.submit(null, 'DELETE_CLOSE');
	// 	//this.props.rootState.triggerAction('logout');
	// 	return false;
	// };

	render() {

		const {anchorEl, anchorE2} = this.state;

		let {rootState} = this.props;
		let {name, locations, userAccess, user} = rootState;
		if(window.innerWidth <1200){
			name = name.split(' ');
			name = name[0][0] + name[1][0];
		}
		/** @type {Locations_Object} location */
		let location = locations[0] || null;
		const redirectToPrevious = () => window.location.replace('/dispositions/one_page/0');
		//sm-button is used by the framework to remove them from display on smaller screens since all of them can be found in the name drop down
		return (
			<ul className="list-unstyled float-right" id="nav-list-right">
				<li>
					{!rootState.kioskMode && <Notification locations={rootState.locations}/>}

					{userAccess <= Access.Manager && !rootState.kioskMode &&
					<Link to={"/security"}>
						<Button data-id={"security"} className="md-button header-btn sm-button" color={'none'}>
							<i className={"fa fa-shield fa-lg"}/></Button>
					</Link>}

					{rootState.kioskMode === '1' &&
						<Button style={{backgroundColor: "#ef5350", color: "black"}} onClick={redirectToPrevious} className="md-button header-btn tablet-button">
							<i className={"fa fa-pencil"}/>&nbsp;&nbsp;Start 4473</Button>}
					{rootState.kioskMode === '1' &&
					<Button onClick={redirectToPrevious} className="md-button header-btn tablet-button" color={'none'}>
						<i className={"fa fa-pencil"}/>&nbsp;&nbsp;Edit Previous</Button>}

					{rootState.kioskMode === '2' && location &&
					<Link to={'/locations/' + location.pkey} className="md-button header-btn sm-button" color={'none'}>
						<i className={"fa fa-book"}/>&nbsp;&nbsp;Bound Book</Link>}

					{rootState.kioskMode &&
					<Button onClick={this.handleUnlockPin} className="md-button header-btn tablet-button" color={'none'}>
						<i className={"fa fa-lock"}/>&nbsp;&nbsp;Unlock Device</Button>}

					{!rootState.kioskMode && (!process.env.production || window.location.hash === '#api' ) &&
					<Button
						name="anchorE2"
						aria-owns={anchorE2 ? 'api-menu' : null}
						aria-haspopup="true"
						onClick={this.handleOpen}
						className="md-button header-btn menu-button sm-button"
						color={'none'}
					>
						<HTTPSIcon/>
						{/*<i className={'fa fa-angle-down'}/>*/}
					</Button>}

					{!rootState.kioskMode &&
					<Button
						name="anchorEl"
						aria-owns={anchorEl ? 'user-menu' : null}
						aria-haspopup="true"
						onClick={this.handleOpen}
						className="md-button header-btn menu-button"
						color={'none'}
					>
						<PersonIcon/>
						<span style={{margin: '0 6px'}}>{name}</span>
						<i className={'fa fa-angle-down'}/>
					</Button>}

					<Button onClick={this.handleLogout} data-id={'log-out-btn'} color={'none'} className="md-button header-btn sm-button" id={'logout-btn'}>
						<LogOutIcon/>
					</Button>

					<Menu
						id="user-menu"
						anchorEl={anchorEl}
						open={Boolean(anchorEl)}
						onClose={this.handleClose}
						getContentAnchorEl={null}
						anchorOrigin={{horizontal: 'right', vertical: 'bottom'}}
						transformOrigin={{horizontal: 'right', vertical: 'top'}}
					>
						{userAccess <= Access.Supervisor && <MenuItem onClick={this.handleRoute('/locations')}>
							<ListItemIcon><i className={"fa fa-book fa-lg"}/></ListItemIcon>
							<ListItemText inset primary="FFLs (Locations)"/>
						</MenuItem>}
						{userAccess <= Access.Manager && <MenuItem onClick={this.handleRoute('/accounts')}>
							<ListItemIcon><i className={"fa fa-address-card-o fa-lg"}/></ListItemIcon>
							<ListItemText inset primary="Account Settings"/>
						</MenuItem>}
						{user && <MenuItem onClick={this.handleRoute('/users/' + user)}>
							<ListItemIcon><i className={"fa fa-user fa-lg"}/></ListItemIcon>
							<ListItemText inset primary="User Settings"/>
						</MenuItem>}
						{userAccess <= Access.Manager && <MenuItem onClick={this.handleRoute('/accounts#billing')}>
							<ListItemIcon><i className={"fa fa-usd fa-lg"}/></ListItemIcon>
							<ListItemText inset primary="Billing"/>
						</MenuItem>}
						{userAccess <= Access.Manager && <MenuItem onClick={this.handleRoute('/accounts/market_place')}>
							<ListItemIcon><i className={"fa fa-files-o fa-lg"}/></ListItemIcon>
							<ListItemText inset primary="Marketplace"/>
						</MenuItem>}
						{userAccess <= Access.Manager && <MenuItem onClick={this.handleRoute('/users')}>
							<ListItemIcon><i className={"fa fa-users fa-lg"}/></ListItemIcon>
							<ListItemText inset primary="Users"/>
						</MenuItem>}
						{userAccess <= Access.Manager &&<MenuItem onClick={this.handleRoute('/kiosks')}>
							<ListItemIcon><i className={"fa fa-tablet fa-lg"}/></ListItemIcon>
							<ListItemText inset primary="Kiosks"/>
						</MenuItem>}
						{userAccess <= Access.Manager && <MenuItem onClick={this.handleRoute('/security')}>
							<ListItemIcon><i className={'fa fa-shield fa-lg'}/></ListItemIcon>
							<ListItemText inset primary="Security Center"/>
						</MenuItem>}
						<MenuItem onClick={() => window.open("https://fflsoftwarepro.freshdesk.com/")}>
							<ListItemIcon><HelpCenterIcon/></ListItemIcon>
							<ListItemText inset primary="Help Center"/>
						</MenuItem>
						<MenuItem onClick={async () => {
							await API.clearCache();
							this.setState({anchorEl: null});
						}}>
							<ListItemIcon><i className={'fa fa-refresh fa-lg'}/></ListItemIcon>
							<ListItemText inset primary="Clear API Cache"/>
						</MenuItem>
						{/*<MenuItem onClick={this.handleCloseSession}>*/}
						{/*	<ListItemIcon>*/}
						{/*		<LogOutIcon/>*/}
						{/*	</ListItemIcon>*/}
						{/*	<ListItemText inset primary="Logout w/o Redirect"/>*/}
						{/*</MenuItem>*/}
						<MenuItem onClick={this.handleLogout}>
							<ListItemIcon>
								<LogOutIcon/>
							</ListItemIcon>
							<ListItemText inset primary="Logout"/>
						</MenuItem>
					</Menu>

					<Menu
						id="api-menu"
						anchorEl={anchorE2}
						open={Boolean(anchorE2)}
						onClose={this.handleClose}
						getContentAnchorEl={null}
						anchorOrigin={{horizontal: 'right', vertical: 'bottom'}}
						transformOrigin={{horizontal: 'right', vertical: 'top'}}
					>
						<MenuItem onClick={this.handleAPIChange('https://api.fflboss.com')}>
							<ListItemIcon><i className={"fa fa-circle"+(API.URL==='https://api.fflboss.com'?'':'-o')+" fa-lg"}/></ListItemIcon>
							<ListItemText inset primary="api.fflboss.com"/>
						</MenuItem>
						{!process.env.production && <MenuItem onClick={this.handleAPIChange('https://beta.api.fflboss.com')}>
							<ListItemIcon><i className={"fa fa-circle"+(API.URL==='https://beta.api.fflboss.com'?'':'-o')+" fa-lg"}/></ListItemIcon>
							<ListItemText inset primary="beta.api.fflboss.com"/>
						</MenuItem>}
						{!process.env.production && <MenuItem onClick={this.handleAPIChange('https://dev.api.fflboss.com')}>
							<ListItemIcon><i className={"fa fa-circle"+(API.URL==='https://dev.api.fflboss.com'?'':'-o')+" fa-lg"}/></ListItemIcon>
							<ListItemText inset primary="dev.api.fflboss.com"/>
						</MenuItem>}
						<MenuItem onClick={this.handleAPIChange('https://tx1.api.fflboss.com')}>
							<ListItemIcon><i className={"fa fa-circle"+(API.URL==='https://tx1.api.fflboss.com'?'':'-o')+" fa-lg"}/></ListItemIcon>
							<ListItemText inset primary="tx1.api.fflboss.com"/>
						</MenuItem>
						<MenuItem onClick={this.handleAPIChange('https://ca1.api.fflboss.com')}>
							<ListItemIcon><i className={"fa fa-circle"+(API.URL==='https://ca1.api.fflboss.com'?'':'-o')+" fa-lg"}/></ListItemIcon>
							<ListItemText inset primary="ca1.api.fflboss.com"/>
						</MenuItem>
						<MenuItem onClick={this.handleAPIChange('https://va1.api.fflboss.com')}>
							<ListItemIcon><i className={"fa fa-circle"+(API.URL==='https://va1.api.fflboss.com'?'':'-o')+" fa-lg"}/></ListItemIcon>
							<ListItemText inset primary="va1.api.fflboss.com"/>
						</MenuItem>

					</Menu>

				</li>
			</ul>
		);
	}
}

export default Framework.Components.withRootState(withRouter(NavRightList));
